import GroupFolderAction from '../utils/GroupFolderAction';
import getRequestWithHeader from '../utils/getRequestWithHeader';
import { HttpReadyState } from 'owa-http-status-codes';
import type { CreateGroupFolderRestResponse } from '../schema/CreateGroupFolderRestResponse';
import type { GroupFolderRestRequest } from '../schema/GroupFolderRestRequest';
import loc from 'owa-localize';
import {
    AccessTokenError,
    RequestTimeout,
    RequestError,
} from '../strings/ErrorMessages.locstring.json';
import parseGroupsRestResponse from '../utils/parseGroupsRestResponse';

/**
 * Create folder under Group Inbox or any other folder (under the group) as specified
 * @param accessToken the auth token for rest api
 * @param groupId the smtp address of group
 * @param diplayName the name of the folder to be created
 * @param parentFolderId the folder under which the sub folder is to be created
 */
export async function createGroupFolderRest(
    accessToken: string,
    groupId: string,
    diplayName: string,
    parentFolderId: string
): Promise<CreateGroupFolderRestResponse> {
    if (!accessToken) {
        return {
            Success: false,
            ErrorMessage: loc(AccessTokenError),
        };
    }

    return new Promise<CreateGroupFolderRestResponse>(resolve => {
        const request = getRequestWithHeader(
            accessToken,
            GroupFolderAction.CreateFolder,
            groupId,
            parentFolderId
        );
        let groupFolderInput: GroupFolderRestRequest = {
            DisplayName: diplayName,
            ParentFolderId: parentFolderId,
        };
        const serializedRequest: string = JSON.stringify(groupFolderInput);

        request.onreadystatechange = function () {
            if (request.readyState === HttpReadyState.Done) {
                resolve(
                    parseGroupsRestResponse(
                        GroupFolderAction.CreateFolder,
                        request.status,
                        request.responseText
                    )
                );
            }
        };

        request.ontimeout = function () {
            resolve({
                Success: false,
                ErrorMessage: loc(RequestTimeout),
            });
        };

        request.onerror = function () {
            resolve({
                Success: false,
                ErrorMessage: loc(RequestError),
            });
        };
        request.send(serializedRequest);
    });
}
